import { Button } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { AuctionBidsAPIUseCaseInterface } from 'application/usecases/AuctionBidsUseCase';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import {
    completeFetching,
    showAlert,
    showConfirm,
    startFetching,
} from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { commonHelpers } from 'utilities/helpers';
import { AuctionBidsPrice } from '../CU-014-02/models/AuctionBids';
import ContentComponent from './components/ContentComponent';
import SelectComponent from './components/SelectComponent';

interface props {
    auctionBidsUseCase: AuctionBidsAPIUseCaseInterface;
}

const BID_PRICE_STATUS_BY_NOW = '10';

const CU01301Page = ({ auctionBidsUseCase }: props) => {
    const dispatch = useAppDispatch();
    const { listedPropertyId } = useParams();
    const location = useLocation();
    const [form] = useForm();
    const navigate = useNavigate();
    const [valueSelect, setValueSelect] = useState('');
    const [auctionBidsPrice, setAuctionBidsPrice] = useState<AuctionBidsPrice>();

    useEffect(() => {
        (async () => {
            await [getAuctionBidsPrice({ listedPropertyId: Number(listedPropertyId) })];
        })();
    }, []);

    const getAuctionBidsPrice = async (params: { listedPropertyId: number }) => {
        try {
            dispatch(startFetching());
            const response = await auctionBidsUseCase.getAuctionBidsPrice(params);
            if (response.result) {
                setAuctionBidsPrice(response.result);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const checkBidPrice = (value: any) => {
        //check if the bid price is the highest price and has other people bid highest price
        const highestPrice = location?.state?.currentHighestAuctionPrice;
        const yourBidPriceOld = location?.state?.yourAuctionBid;
        // if (highestPrice && highestPrice == valueSelect && highestPrice == askingSalePriceUpperLimit) {
            //user bid the highest price
            if (yourBidPriceOld == highestPrice) {
                //user didn't bid before or user is the first one bid the highest price
                const confirmProps = commonHelpers.getConfirmProps('CU-013-01-02', {
                    onOk() {
                        submit(value);
                    },
                });
                dispatch(showConfirm(confirmProps));
                return true;
            }
        submit(value);
    };

    const submit = async (value: any) => {
        try {
            dispatch(startFetching());
            const params = {
                auctionId: Number(location.state.auctionId),
                scheduleSeq: Number(location.state.currentScheduleSeq),
                bidPrice: Number(valueSelect),
            };
            const response = await auctionBidsUseCase.creatAuctionBids(params);
            if (response.result) {
                //can't bid
                if (response.result?.code) {
                    const errCode = `N0${response.result?.code}`;
                    const alerProps = commonHelpers.getAlertPropsByErrCode(errCode);

                    dispatch(showAlert(alerProps));
                } else {
                    const status = response.result?.bidPriceStatus;
                    const isWinningBid = response.result?.isWinningBid;
                    if (status === BID_PRICE_STATUS_BY_NOW) {
                        //people bid success with the highest price
                        if (isWinningBid) {
                            //the 1st people bid with the highest price
                            dispatch(
                                showConfirm(
                                    commonHelpers.getConfirmProps('CU-013-01-01', {
                                        onOk() {
                                            navigate(
                                                `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_014_02}/${location.state.auctionId}`,
                                            );
                                        },
                                        onCancel(){
                                            navigate(
                                                `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_02}`,
                                            );
                                        }
                                    }),
                                ),
                            );
                        } else {
                            //the 2nd people bid with the highest price
                            dispatch(
                                showAlert(
                                    commonHelpers.getConfirmProps('CU-013-01-02', {
                                        onOk() {
                                            navigate(
                                                `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.DASHBOARD}`,
                                            );
                                        },
                                    }),
                                ),
                            );
                        }
                    } else {
                        //people bid success with the price lower than the highest price
                        if(isWinningBid){
                            dispatch(
                                showAlert(
                                    commonHelpers.getConfirmProps('CU-002-02-01', {
                                        onOk() {
                                            navigate(
                                                `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.DASHBOARD}`,
                                            );
                                        },
                                    }),
                                ),
                            );
                        } else {
                            dispatch(
                                showAlert(
                                    commonHelpers.getConfirmProps('CU-002-02-02', {
                                        onOk() {
                                            navigate(
                                                `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.DASHBOARD}`,
                                            );
                                        },
                                    }),
                                ),
                            );
                        }
                    }
                }
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    return (
        <div className="cu-013-01-wrapper">
            <PageTitle title="入札" />
            <section className="center-inside">
                <div className="content-container">
                    <div className="text-title-large">{location?.state?.name}</div>
                    <SelectComponent
                        valueSelect={valueSelect}
                        onChangeSelect={(value) => setValueSelect(value)}
                        form={form}
                        selectData={auctionBidsPrice}
                    />
                    <ContentComponent data={location.state} />
                    <div className="btn-container">
                        <Button
                            onClick={checkBidPrice}
                            type="primary"
                            form="form-select"
                            style={{ width: '343px', height: '56px' }}
                            disabled={!valueSelect}
                        >
                            入札する
                        </Button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CU01301Page;
